import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges class names using clsx and tailwind-merge
 * This helps avoid class conflicts when using Tailwind utility classes
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
